export default __webpack_public_path__ + "static/media/1.4d4af2bf.jpg";